import React, { useState } from "react";
import { connect } from 'react-redux';
import { EaseDrawer } from "../../libs/EaseDrawer";
import get from 'lodash/get';
import { Text1, Text3, Text4, Text5 } from "../../styles";
import { Descriptions, Button, Badge, Spin, Card, Empty, Icon } from "antd";
import { alertify, handleApiExceptions, printRupee, getObjectFromArray } from "../../app_methods";
import { DISBURSEMENTS_STATUS_TYPES, SMART_COLLECT_TRANSACTIONS_STATUS_TYPES } from "../../constants";
import { SmartCollectRefundModal } from '../Common';
import { SmartCollectTransaction, SmartCollectTransactionOrders } from '../../models';
import moment from 'moment';
import { updateCurrentUserAction } from "../../redux/actions";
import { MerchantService } from "../../services";
import { PermissionHoc } from '../HOC';
import { CAPTURE_MODES } from "./constants";

const PermissableButton = PermissionHoc(Button, null, { is_component: true, fallbackComponent: null })


const TransactionDetailsDrawer = (props) => {
    const [transactionDetails, setTransactionDetails] = useState({});
    const [isRetrieving, setIsRetrieving] = useState(false);
    const [isRefunding, setIsRefunding] = useState(false);
    const [showRefundModal, setShowRefundModal] = useState(false);
    const [isReTriggeringWebHook, setIsReTriggeringWebHook] = useState(false);
    const [isReTriggeringOrderWebHook, setIsReTriggeringOrderWebHook] = useState(false);
    const [isUpdating, setUpdating] = useState(false);
    const virtual_account_settings = props.current_user.smart_collect_virtual_account_settings
    const triggerWebhook = getObjectFromArray(props.current_user?.instacollect_webhook_settings|| [], "event_name", "TRANSACTION_CREDIT") || {};

    const fetchMerchantInfo = () => {
        MerchantService.fetch().then((response) => {
            if (response.success) props.updateCurrentUser(response.data.merchant);
        });
    };

    const retrieveTransaction = async () => {
        if (!props.current_user.key) return;
        setIsRetrieving(true);
        const response = await props.transaction.retrieve({ is_submerchant: props.transaction.is_submerchant });
        if (!response.success) {
            setIsRetrieving(false);
            handleApiExceptions(response);
            return;
        }
        setTransactionDetails(response.data.transaction);
        props.fetchTransactions();
        setIsRetrieving(false);
    };

    const raiseRefund = async (data) => {
        if (!props.current_user.key) return;
        setIsRefunding(true);
        const va = new SmartCollectTransaction({ 'id': data.id });
        const response = await va.initiate_refund(data);
        if (!response.success) {
            setIsRefunding(false);
            handleApiExceptions(response);
            return;
        }
        toggleSmartCollectRefundModal();
        fetchMerchantInfo();
        alertify("Success", "Refund initiated successfully.", "success");
        retrieveTransaction();
        setIsRefunding(false);
    };

    const toggleSmartCollectRefundModal = () => {
        setShowRefundModal(!showRefundModal);
    }

    const reTriggerWebhook = async () => {
        setIsReTriggeringWebHook(true);
        const transaction = new SmartCollectTransaction(props.transaction);
        const response = await transaction.retrigger_webhook();
        if (!response.success) {
            setIsReTriggeringWebHook(false);
            handleApiExceptions(response);
            return;
        }
        setIsReTriggeringWebHook(false);
        let message = response.data.message;
        alertify("Success", message, "success");
    }

    const reTriggerOrderWebhook = async (id) => {
        setIsReTriggeringOrderWebHook(true);
        const transaction_order = new SmartCollectTransactionOrders({ 'id': id });
        const response = await transaction_order.retrigger_webhook();
        if (!response.success) {
            setIsReTriggeringOrderWebHook(false);
            handleApiExceptions(response);
            return;
        }
        setIsReTriggeringOrderWebHook(false);
        let message = response.data.message;
        alertify("Success", message, "success");
    }

    const capture_transaction = async (type = '') => {
        setUpdating(true);
        const transaction = new SmartCollectTransaction();
        let response = await transaction.update_status({ id: props.transaction.id });
        if (type == 'order') {
            const transaction_order = new SmartCollectTransactionOrders();
            response = await transaction_order.update_status({ id: props.transaction.transaction_order.id });
        }
        if (!response.success) {
            setUpdating(false);
            handleApiExceptions(response);
            return;
        }
        setUpdating(false);
        retrieveTransaction();
        props.fetchTransactions()
        let message = response.data.message;
        alertify("Success", message, "success");
    }

    const renderTitle = () => {
        return (
            <div className={`${props.transaction.is_submerchant ? 'mb-4' : 'mb-1'} ${props.transaction.transaction_order && 'mb-4'}`}>
                <Text1 className="d-block" strong>Transaction Details</Text1>
                <Text5 copyable>{transactionDetails.id}</Text5>
            </div>
        )
    };  

    const renderDetails = () => {
        return (
            <>
                { get(transactionDetails, "metadata.manual_capture_enabled") ?
                    <PermissableButton required_permission="IC_TRANSACTION_CAPTURE" className='float-right mb-2 ml-2' icon='code' size='small' loading={isUpdating} onClick={() => capture_transaction()}>Capture</PermissableButton>
                    : null}
                { 
                    ( virtual_account_settings?.notification_settings?.webhook_enabled && triggerWebhook?.is_enable && !props.transaction.is_submerchant && !props.transaction.transaction_order) && <Button className='float-right mb-2' icon='code' size='small' loading={isReTriggeringWebHook} onClick={() => reTriggerWebhook()}> Trigger Webhook </Button>
                }

                <Descriptions className="mb-4" column={1} size="small" bordered>
                    <Descriptions.Item label="Sender Name">{transactionDetails.remitter_full_name || "---"}</Descriptions.Item>
                    {
                        transactionDetails.payment_mode == "UPI" ? <>
                            <Descriptions.Item label="UPI Handle">{transactionDetails.remitter_upi_handle || "---"}</Descriptions.Item>
                            <Descriptions.Item label="Remitter Phone Number">{transactionDetails.remitter_phone_number || "---"}</Descriptions.Item>
                        </>
                            : <>
                                <Descriptions.Item label="Account Number">{transactionDetails.remitter_account_number || "---"}</Descriptions.Item>
                                <Descriptions.Item label="Account IFSC">{transactionDetails.remitter_account_ifsc || "---"}</Descriptions.Item>
                            </>
                    }
                    {/* <Descriptions.Item label="Payment Mode">{transactionDetails.payment_mode || "---"}</Descriptions.Item> */}
                    <Descriptions.Item label="Amount">{(transactionDetails.amount && printRupee(transactionDetails.amount)) || "---"}</Descriptions.Item>
                    <Descriptions.Item label="Payment Mode">{transactionDetails.payment_mode || "---"}</Descriptions.Item>
                    <Descriptions.Item label="Narration">{transactionDetails.narration || "---"}</Descriptions.Item>
                    <Descriptions.Item label="Unique Transaction Reference">{transactionDetails.unique_transaction_reference || "---"}</Descriptions.Item>
                    <Descriptions.Item label="Transaction Date">{(transactionDetails.transaction_date && moment(transactionDetails.transaction_date).format("LLL")) || "---"}</Descriptions.Item>
                    <Descriptions.Item label="Settlement Date">{(transactionDetails.settlement_date && moment(transactionDetails.settlement_date).format("LLL")) || "---"}</Descriptions.Item>
                    <Descriptions.Item label="Platform Charges">{(transactionDetails.service_charge && printRupee(transactionDetails.service_charge)) || printRupee(0)}</Descriptions.Item>
                    <Descriptions.Item label="GST">{(transactionDetails.gst_amount && printRupee(transactionDetails.gst_amount)) || printRupee(0)}</Descriptions.Item>
                    <Descriptions.Item label="Total Charges">{(transactionDetails.service_charge_with_gst && printRupee(transactionDetails.service_charge_with_gst)) || printRupee(0)}</Descriptions.Item>
                    <Descriptions.Item label="Status">
                        {(transactionDetails.status && (
                            <Badge
                                color={SMART_COLLECT_TRANSACTIONS_STATUS_TYPES[transactionDetails.status].color}
                                text={<Text4>{SMART_COLLECT_TRANSACTIONS_STATUS_TYPES[transactionDetails.status].label}</Text4>}
                            />
                        )) || "---"}
                    </Descriptions.Item>
                    {transactionDetails?.hold_details?.note ? (
                        <Descriptions.Item label="Note">{transactionDetails?.hold_details?.note || "---"}</Descriptions.Item>
                    ) : null}
                    {transactionDetails?.has_submerchant_access && (
                        <>
                        <Descriptions.Item label="Merchant Name">{ transactionDetails.merchant?.name || "---"}</Descriptions.Item>
                        <Descriptions.Item label="Merchant Email">{ transactionDetails.merchant?.email || "---"}</Descriptions.Item>
                        </>
                    )}

                    <Descriptions.Item label="UPI Type">{transactionDetails?.upi_type}</Descriptions.Item>
                    <Descriptions.Item label="Failure Code">{transactionDetails?.error_meta?.status_code || "---"}</Descriptions.Item>
                    <Descriptions.Item label="Failure Reason">{transactionDetails?.error_meta?.description || "---"}</Descriptions.Item>

                </Descriptions>
                {transactionDetails.metadata?.auto_refund_date ? renderCaptureDetails():null}
                {/* {transactionDetails.metadata?.upi_params_tid ? renderMetadata():null} */}
                {(transactionDetails.metadata?.upi_params_tid || transactionDetails.metadata?.upi_params_tr) ? renderMetadata() : null}
            </>
        )
    };

    const renderMetadata = () => {
        return (
            <>
                <div className="mt-2 mb-2">
                    <Text3 className="d-block" strong>Extra Details</Text3>
                </div>
                <Descriptions className="mb-4" column={1} size="small" bordered>
                    <Descriptions.Item label="UPI tid">{(transactionDetails.metadata && transactionDetails.metadata.upi_params_tid)}</Descriptions.Item>
                    <Descriptions.Item label="UPI tr">{(transactionDetails.metadata && transactionDetails.metadata.upi_params_tr)}</Descriptions.Item>
                </Descriptions>
            </>
        )
    };

    const renderOrderDetails = () => {
        return (
            <>
                <div className="mt-2 mb-2">
                    <Text3 className="d-block" strong>Order Details</Text3>
                    <Text5 copyable>{props.transaction.transaction_order.id}</Text5>
                </div>
                {props.transaction.transaction_order.status == 7 ?
                    <Button className='float-right mb-2 mr-2' icon='code' size='small' loading={isUpdating} onClick={() => capture_transaction('order')}> Capture </Button>
                    : null}
                {(props.current_user?.smart_collect_virtual_account_settings?.notification_settings?.webhook_url && props.current_user?.smart_collect_virtual_account_settings?.notification_settings?.webhook_enabled && !props.transaction.is_submerchant) && <Button className='float-right mb-2' icon='code' size='small' loading={isReTriggeringOrderWebHook} onClick={() => reTriggerOrderWebhook(props.transaction.transaction_order.id)}> Trigger Webhook </Button>}
                {props.transaction && props.transaction.transaction_order &&
                    <Descriptions className="mb-4" column={1} size="small" bordered>
                        <Descriptions.Item label="Customer Name">{props.transaction.transaction_order.customer_name || "---"}</Descriptions.Item>
                        <Descriptions.Item label="Customer Email">{props.transaction.transaction_order.customer_email || "---"}</Descriptions.Item>
                        <Descriptions.Item label="Customer Phone">{props.transaction.transaction_order.customer_phone || "---"}</Descriptions.Item>
                        <Descriptions.Item label="Amount">{(props.transaction.transaction_order.amount && printRupee(props.transaction.transaction_order.amount)) || "---"}</Descriptions.Item>
                        <Descriptions.Item label="Unique Request Number">{props.transaction.transaction_order.unique_request_number || "---"}</Descriptions.Item>
                    </Descriptions>
                }
            </>
        )
    }

    const renderRefundDetails = () => {
        if (!props.current_user.icef || !transactionDetails.status || ["failure", "pending", "timed_out", "uncaptured"].includes(transactionDetails.status) || transactionDetails?.virtual_account?.via_teller) return;

        // const refunds = transactionDetails?.disbursements?.length && transactionDetails.disbursements.filter((dibsursement) => dibsursement.disbursement_type === "refund")
        return (
            <>
            {/* {transactionDetails?.refundable_amount>0? */}
            {["unsettled", "received", "refunded", "partially_refunded"].includes(transactionDetails?.status)
                && transactionDetails?.virtual_account?.van_provider_code !== "BOM" ?
                <div className="w-100 d-flex justify-content-between">
                    <Text3 className="d-block" style={{ marginBottom: '8px', color: 'black' }} strong>Refund Requests</Text3>
                    {["unsettled", "received","partially_refunded"].includes(transactionDetails?.status) && transactionDetails?.refundable_amount>0 &&  transactionDetails.refunds && transactionDetails.refunds.length ? <PermissableButton required_permission="IC_CVA_TRANSACTIONS_REFUND" className="p-0" type="link" onClick={toggleSmartCollectRefundModal} disabled={props.transaction.is_submerchant}>+ Raise Refund</PermissableButton> : null}
                </div>:null}

                {transactionDetails && transactionDetails && ["unsettled", "received","partially_refunded", "refunded"].includes(transactionDetails?.status) && transactionDetails.refunds && transactionDetails.refunds.length ?
                    transactionDetails.refunds.map(refund => (
                        <Card
                            className="mb-2"
                            size="small"
                            title={false}
                        >
                            <div className="mb-2 d-flex justify-content-between">
                                <Text4 className="font-italic">{refund.disbursement_date ? moment(refund.disbursement_date).format("LLL") : refund.status === "pending" ? "Yet to Initiate" : "---"}</Text4>
                                <Badge
                                    color={DISBURSEMENTS_STATUS_TYPES[refund.status].color}
                                    text={<Text4>{DISBURSEMENTS_STATUS_TYPES[refund.status].label}</Text4>}
                                />
                            </div>
                            <div className="d-flex justify-content-between">
                                <Text4 strong>Refund Amount:</Text4>
                                <Text4>{printRupee(refund.amount)}</Text4>
                            </div>
                            <div className="d-flex justify-content-between">
                                <Text4 strong>Unique Transaction Reference:</Text4>
                                <Text4>{refund.unique_transaction_reference || "---"}</Text4>
                            </div>
                        </Card>
                    ))
                :
                transactionDetails && ["unsettled", "received"].includes(transactionDetails?.status) &&  transactionDetails?.refundable_amount>0 && transactionDetails?.virtual_account?.van_provider_code !== "BOM"?<Empty children={<PermissableButton required_permission="IC_CVA_TRANSACTIONS_REFUND" onClick={toggleSmartCollectRefundModal} disabled={props.transaction.is_submerchant}>Raise Refund</PermissableButton>} description={<Text4 secondary> No refund request found.</Text4>} imageStyle={{ marginTop: "15px 0 10px 0", opacity: 0.9 }} />:null
                }
            </>
        )
    };
    
    const renderChargebackDetails = () => {
        const chargebacks = transactionDetails?.chargebacks
        return (
            <>
                <div className="w-100 d-flex justify-content-between">
                    {!!chargebacks?.length && <Text3 className="d-block" style={{ marginBottom: '8px', color: 'black' }} strong>Chargeback Details</Text3>}
                </div>
                {chargebacks?.length ?
                    chargebacks.map(chargeback => (
                        <Card
                            className="mb-2"
                            size="small"
                            title={false}
                        >
                            <div className="mb-2 d-flex justify-content-between">
                                <Text4 className="font-italic">{chargeback.created_at ? moment(chargeback.created_at).format("LLL") : "---"}</Text4>
                                <Badge
                                    color={DISBURSEMENTS_STATUS_TYPES[chargeback.status].color}
                                    text={<Text4>{DISBURSEMENTS_STATUS_TYPES[chargeback.status].label}</Text4>}
                                />
                            </div>
                            <div className="d-flex justify-content-between">
                                <Text4 strong>Chargeback Amount:</Text4>
                                <Text4>{printRupee(chargeback.amount)}</Text4>
                            </div>
                            <div className="d-flex justify-content-between">
                                <Text4 strong>Unique Transaction Reference:</Text4>
                                <Text4>{chargeback.unique_transaction_reference || "---"}</Text4>
                            </div>
                        </Card>))
                    :
                    null
                }
            </>
        )
    };

    const renderCaptureDetails = () => {
        return (
            <>
                <div className="mt-2 mb-2">
                    <Text3 className="d-block" strong>Capture Details</Text3>
                </div>
                <Descriptions className="mb-4" column={1} size="small" bordered>
                    {transactionDetails.metadata.captured_via && <Descriptions.Item label="Captured Via">{transactionDetails.metadata.captured_via? CAPTURE_MODES[transactionDetails.metadata.captured_via] : "---"}</Descriptions.Item>}
                    {transactionDetails.metadata.captured_via && <Descriptions.Item label="Captured At">{transactionDetails.metadata.captured_at && moment(transactionDetails.metadata.captured_at).format("LLL") || "---"}</Descriptions.Item>}
                    {!transactionDetails.metadata.captured_via && <Descriptions.Item label="Auto Refund Date">{transactionDetails.metadata.auto_refund_date && moment(transactionDetails.metadata.auto_refund_date).format("LLL") || "---"}</Descriptions.Item>}
                </Descriptions>
            </>
        )
        };

    const user_permissions = props.current_user.user ? props.current_user.user.permissions : [] || [];
    return (
        <EaseDrawer
            title={false}
            width={500}
            visible={props.visible}
            onOpen={retrieveTransaction}
            onClose={props.onClose}
            centered
            hideHeader
            hideFooter
            destroyOnClose
        >
            <div className="mt-3">
                {renderTitle()}
                {
                    isRetrieving ?
                        <div className="h-100 w-100 d-flex justify-content-center align-items-center"><Spin spinning={true} tip="Fetching details..." /></div>
                        :
                        <>
                            {renderDetails()}
                            {props.transaction && props.transaction.transaction_order && renderOrderDetails()}
                            {transactionDetails.provider_code !== "IDFC" && renderRefundDetails()}
                            {renderChargebackDetails()}
                        </>
                }
            </div>
            <SmartCollectRefundModal
                visible={showRefundModal}
                toggleSmartCollectRefundModal={toggleSmartCollectRefundModal}
                transaction={transactionDetails}
                onSubmit={raiseRefund}
                loading={isRefunding}
                virtual_account_settings={virtual_account_settings}
            />
        </EaseDrawer>
    )
};

const mapStateToProps = state => ({
    current_user: state.userReducer.current_user
})

const mapDispatchToProps = dispatch => ({
    updateCurrentUser: user => dispatch(updateCurrentUserAction(user))
})

export default connect(mapStateToProps, mapDispatchToProps)(TransactionDetailsDrawer);